/* Copyright (c) 2023 TORITI */

import Request from './request';

export default class TaskService {
  static async getList(query = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'get',
        path: 'task/getList',
        query
      }).then((result = {}) => {
        const { data } = result;
        return resolve({ isSuccess: true, data });
      });
    });
  }
  static async create(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: 'task/create',
        data
      }).then((result = {}) => {
        return resolve(result);
      });
    });
  }
}
